module.exports = __webpack_public_path__ + "img/11.3a35b8d2.jpg";